<template>
  <div class="item">
    <template v-for="(item, index) in list">
      <template v-if="item.child && item.child.length" >
        <div :key="index">
          <div class="flex-between label" :class="activeIndex === item.id ? 'active' : ''">
            <div class="flex-row label-item">
              <i class="el-icon-arrow-down icon" @click="handleCollapse(item)"></i>
              <p class="title icon flex" @click="handleClick(item)">{{ item.name }}</p>
            </div>
            <el-dropdown trigger="click" @command="handleCommand(item, $event, index)">
            <span class="el-dropdown-link">
              <i class="el-icon-more icon"></i>
            </span>
              <el-dropdown-menu slot="dropdown" >
                <el-dropdown-item command="add">添加摄像头</el-dropdown-item>
                <el-dropdown-item command="edit">编辑</el-dropdown-item>
                <el-dropdown-item command="delete">删除</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <el-collapse-transition>
            <ul v-show="showIndex === item.id && isShow">
              <li
                v-for="(child, childIndex) in item.child"
                :key="childIndex">
                <p
                  class="label title child"
                  :class="{active: activeIndex === child.childId}"
                  @click="handleClick(child)">{{ child.name }}</p>
              </li>
            </ul>
          </el-collapse-transition>
        </div>
      </template>
      <template v-else>
        <div class="flex-between label" :class="activeIndex === item.id ? 'active' : ''">
          <div class="flex-row label-item">
            <!--<i class="el-icon-arrow-down icon" @click="handleCollapse(item)"></i>-->
            <p class="title icon flex" @click="handleClick(item)">{{ item.name }}</p>
          </div>
          <el-dropdown trigger="click" @command="handleCommand(item, $event, index)">
            <span class="el-dropdown-link">
              <i class="el-icon-more icon"></i>
            </span>
            <el-dropdown-menu slot="dropdown" >
              <el-dropdown-item command="add">添加摄像头</el-dropdown-item>
              <el-dropdown-item command="edit">编辑</el-dropdown-item>
              <el-dropdown-item command="delete">删除</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </template>
    </template>
    <!-- 添加摄像头 -->
    <edit-dialog
      :show="cameraShow"
      :title="'添加摄像头'"
      :model="'cameraShow'"
      :devId="devId"
      :form="camera"
      @success="handleAddCamera"
      @close="handleClose">
    </edit-dialog>
  </div>
</template>

<script>
  import { getDevList, deviceCameraList, editCamera, deleteDevice } from '../../../api/monitor';
  import { setStorage, getStorage, removeStorage } from '@/utils/localStorage';
  import { parseTime } from '@/utils';
  import editDevice from './dialog/device';
  import editDialog from './dialog/camera';
  import common from "./mixin/common";

  export default {
    name: "sidebar-item",
    mixins: [common],
    components: {
      editDevice,
      editDialog
    },
    data() {
      return {
        list: [],
        activeIndex: 0,
        showIndex: 0,
        isShow: true,
        devId: 0,
        cameraShow: false,
        camera: [
          { label: '摄像头名称', key: 'name' },
          { label: '监控数据源', key: 'monitoringUrl' },
          { label: '摄像头区域', key: 'dangerInfoId', type: 'select' },
        ],
      }
    },
    mounted() {
      this.getTokenFn();
    },
    methods: {
      //  获取token
      getTokenFn() {
        this.getKey().then(res => {
          if (res) {
            const deviceToken = JSON.parse(getStorage('appToken'));
            if (deviceToken) {
              if (res.appKey === deviceToken.appKey) {
                if (deviceToken && deviceToken.accessToken) {
                  //  如果本地有token但是过期了,需要重新去请求一次
                  const curDate = new Date().getTime();
                  const expireDate = new Date(deviceToken.token_creation_time).getTime();
                  if (curDate > expireDate) {
                    const { appKey, appSecret, id } = deviceToken;
                    this.getToken({ appKey, appSecret }).then(data => {
                      // if (data.appKey) {
                      if (res.appKey) {
                        const params = {
                          appKey,
                          appSecret,
                          accessToken: data.accessToken,
                          token_creation_time: parseTime(data.expireTime),
                          id
                        }
                        this.editToken(params).then(() => {
                          setStorage('appToken', JSON.stringify(params));
                          this.getDeviceList();
                        })
                      } else {
                        this.$store.state.loading = false;
                        this.$message.error(`请先添加基本信息`)
                      }
                    })
                  } else {
                    this.getDeviceList();
                    // console.log(`未过期`)
                  }
                } else {
                  // console.log(111111,22222)
                  //  如果本地没有token和appk的话,请求一次
                  this.getKey().then(res => {
                    //  使用请求到的appken算,如果没有token的话请求一次,有的话存入使用
                    if (res) {
                      if (res.accessToken) {
                        setStorage('appToken', JSON.stringify(res));
                      } else {
                        const { appKey, appSecret, id } = res;
                        this.getToken({ appKey, appSecret }).then(data => {
                          if (data.accessToken) {
                            const params = {
                              appKey,
                              appSecret,
                              accessToken: data.accessToken,
                              token_creation_time: parseTime(data.expireTime),
                              id
                            }
                            this.editToken(params).then(() => {
                              setStorage('appToken', JSON.stringify(params));
                              this.getDeviceList();
                            })
                          } else {
                            this.$store.state.loading = false;
                            this.$message.error(data.msg)
                          }
                        })
                      }
                    } else {
                      this.$store.state.loading = false;
                      // this.$message.error(`没有appKey`)
                    }
                  })
                }
              } else {
                if (res.accessToken) {
                  setStorage('appToken', JSON.stringify(res));
                } else {
                  const { appKey, appSecret, id } = res;
                  this.getToken({ appKey, appSecret }).then(data => {
                    if (data.accessToken) {
                      const params = {
                        appKey,
                        appSecret,
                        accessToken: data.accessToken,
                        token_creation_time: parseTime(data.expireTime),
                        id
                      }
                      this.editToken(params).then(() => {
                        setStorage('appToken', JSON.stringify(params));
                        this.getDeviceList();
                      })
                    } else {
                      this.$store.state.loading = false;
                      this.$message.error(data.msg)
                    }
                  })
                }
              }
            } else {
              if (res.accessToken) {
                setStorage('appToken', JSON.stringify(res));
              } else {
                const { appKey, appSecret, id } = res;
                this.getToken({ appKey, appSecret }).then(data => {
                  if (data.accessToken) {
                    const params = {
                      appKey,
                      appSecret,
                      accessToken: data.accessToken,
                      token_creation_time: parseTime(data.expireTime),
                      id
                    }
                    this.editToken(params).then(() => {
                      setStorage('appToken', JSON.stringify(params));
                      this.getDeviceList();
                    })
                  } else {
                    this.$store.state.loading = false;
                    this.$message.error(data.msg)
                  }
                })
              }
            }
          } else {
            this.$store.state.loading = false;
            removeStorage('appToken');
          }
        })
      },
      //  点击事件
      handleClick(item) {
        this.activeIndex = item.key === 'device' ? item.id : item.childId;
        this.$store.commit('SET_CAMERA', item);
      },
      //  获取设备名称
      getDeviceList() {
        this.$store.state.loading = true;
        getDevList().then(res => {
          if (res.body.data.length) {
            res.body.data.map((v, i) => {
              v.key = 'device';
              this.getCamera(v, i).then(data => {
                v.child = data
              })
              // v.child = this.getCamera(res.body.data[i]);
              return v;
            })
            setTimeout(() => {
              this.list = res.body.data;
              if(this.list.length) {
                this.handleClick(this.list[0]);
                // this.$store.commit('SET_CAMERA', this.list[0])
                this.showIndex = this.list[0]['id'];
                this.isShow = true;
              }
            }, 2000)
          } else {
            this.$store.state.loading = false;
          }
          // console.log(this.list)
        })
      },
      //  获取摄像头
      async getCamera(item, index) {
        let data = await deviceCameraList({ id: item.id });
        data.body.data.map(v => {
          v.childId = v.id + 666 + index;
          return v;
        })
        setTimeout(() => {
          this.$store.state.loading = false;
        }, 1000)
        return Promise.resolve(data.body.data);
      },
      //  点击展开
      handleCollapse(item) {
        if (item.key === 'device') {
          if (this.showIndex === item.id) {
            this.isShow = !this.isShow;
          } else {
            this.showIndex = item.id;
            this.isShow = true;
          }
        }
      },
      //  操作
      handleCommand(item, key, index) {
        if (key === 'add') {
          this.cameraShow = true;
          this.devId = item.id
        } else if (key === 'edit') {
          this.$emit('editDevice', item);
        } else if (key === 'delete') {
          deleteDevice(item.id).then(() => {
            this.$message.success(`设备删除成功`);
            this.list.splice(index, 1)
          })
        }
      },
      //  添加摄像头
      handleAddCamera() {
        location.reload()
        // this.getDeviceList();
        // console.log(item, id)
      },
      //  关闭弹窗
      handleClose(key) {
        this[key] = false;
      }
    }
  }
</script>

<style scoped lang="scss">
.item {
  .label {
    padding: 10px;
    cursor: pointer;
    &:hover {
      background-color: #f2f2f2;
    }
    &.active {
      color: #409EFF;
      &:hover {
        color: #333;
      }
    }
    .label-item {
      display: flex;
      align-items: center;
      flex: 1;
      .icon {
        white-space: nowrap;
      }
      .flex {
        flex: 1;
      }
    }
  }
  .icon {
    cursor: pointer;
  }
  .title {

    &:hover {
      background-color: #f2f2f2;
    }
    &.active {
      color: #409EFF;
      &:hover {
        color: #333;
      }
    }
    &.child {
      padding-left: 35px;
    }
    &.icon {
      margin-left: 10px;
    }
  }
  .flex-between {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .flex-row {
    display: flex;
    align-items: center;
  }
}
</style>